const topTtl = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let ttl = document.querySelectorAll('.js-com-ttl');
    let end = document.querySelectorAll('.js-com-ttl-end');

    ttl.forEach((element, index) => {
      let to = gsap.to(ttl[index], {
        ease: "none",
        scrollTrigger: {
          trigger: ttl[index],
          start: '100% 100%',
          endTrigger: end[index],
          end: '100% 100%',
          pin: true,
          pinSpacing: false,
          // markers: true
        }
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);
    });



  }
})()
export default topTtl;